/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseMessagingLimit } from '../../models/api-response-messaging-limit';

export interface GetMessagingLimit$Params {
  phoneReference: string;
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getMessagingLimit(http: HttpClient, rootUrl: string, params: GetMessagingLimit$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseMessagingLimit>> {
  const rb = new RequestBuilder(rootUrl, getMessagingLimit.PATH, 'get');
  if (params) {
    rb.path('phoneReference', params.phoneReference, {});
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseMessagingLimit>;
    })
  );
}

getMessagingLimit.PATH = '/v1/api/ui/company/numbers/{phoneReference}/messaging-limit';
